<template>
	<page-container :page="page" :class="page.headingImage ? '' : 'no-slider'">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
				title: page.title || page.header,
				subtitle: page.subtitle,
			}"
		/>

		<section class="main-content contentblocks">
			<div class="row contentblock overflow-hidden">
				<div class="columns column6">
					<div class="contentblock-content">
						<div class="inner-content">
							<div v-parse-links v-html="page.content" />
							<book-button v-if="page.bookingID" class="button cta" :roomid="page.bookingID">
								<span>{{ $t('bookThisRoom') }}</span>
							</book-button>
						</div>
					</div>
					<div class="contentblock-image small fade-animate up">
						<picture>
							<source v-if="page.imageSmallWebp" :srcset="page.imageSmallWebp" type="image/webp" />
							<source :srcset="page.imageSmall" />
							<img loading="lazy" :src="page.imageSmall" :alt="page.imageSmallAlt" />
						</picture>
					</div>
				</div>
				<div class="columns column6">
					<div class="contentblock-image large fade-animate up">
						<picture>
							<source v-if="page.imageLargeWebp" :srcset="page.imageLargeWebp" type="image/webp" />
							<source :srcset="page.imageLarge" />
							<img loading="lazy" :src="page.imageLarge" :alt="page.imageLargeAlt" />
						</picture>
					</div>
				</div>
			</div>

			<div class="row contentblock overflow-hidden">
				<div class="columns column6">
					<div class="contentblock-content">
						<div class="inner-content">
							<div v-parse-links v-html="page.extraContent" />
						</div>
					</div>
					<div class="contentblock-image small fade-animate up">
						<picture>
							<source
								v-if="page.imageSmallExtraWebp"
								:srcset="page.imageSmallExtraWebp"
								type="image/webp"
							/>
							<source :srcset="page.imageExtraSmall" />
							<img loading="lazy" :src="page.imageExtraSmall" :alt="page.imageSmallExtraAlt" />
						</picture>
					</div>
				</div>
				<div class="columns column6">
					<div class="contentblock-image large fade-animate up">
						<picture>
							<source
								v-if="page.imageLargeExtraWebp"
								:srcset="page.imageLargeExtraWebp"
								type="image/webp"
							/>
							<source :srcset="page.imageLargeExtra" />
							<img loading="lazy" :src="page.imageLargeExtra" :alt="page.imageLargeExtraAlt" />
						</picture>
					</div>
				</div>
			</div>
		</section>

		<slider-gallery class="fade-animate up" :items="page.sliderImages" />

		<hotel-facilities
			:header="defaults[locale].homepage.sectionHotelFacilitiesTitle"
			:items="defaults[locale].homepage.hotelFacilities"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();
</script>

<style lang="scss" scoped>
.contentblocks {
	background: var(--contentblock-background-color);
}

.contentblock {
	margin: 80px auto;
	position: relative;
	display: flex;
	flex-flow: row wrap;
	justify-content: flex-start;
	align-items: stretch;

	.column6 {
		display: flex;
		flex-flow: column wrap;
		justify-content: space-between;
		align-items: flex-end;
		padding: 0 25px;
	}

	.contentblock-content {
		position: relative;
		z-index: 2;
		width: 100%;

		.inner-content {
			max-width: 580px;
			margin: 0 0 100px;
		}

		h2 {
			max-width: 600px;
		}
	}

	.contentblock-image {
		img {
			width: 100%;
			height: auto;
		}

		&.large {
			margin-top: 175px;
		}

		&.small {
			max-width: 400px;
		}
	}

	&:nth-child(even) {
		flex-flow: row-reverse wrap;

		.column6 {
			align-items: flex-start;
		}
	}
}

@media (max-width: 920px) {
	.contentblock {
		display: flex;
		flex-flow: wrap column;

		.contentblock-content {
			h2 {
				max-width: 500px;
			}

			.inner-content {
				max-width: 440px;
				margin: 0 0 50px;
			}
		}

		.contentblock-image {
			&.large {
				margin-top: 25px;
			}
		}

		.column6 {
			flex-flow: wrap column !important;
		}
	}
}

@media (max-width: 580px) {
	.contentblock {
		.contentblock-image {
			&.small {
				max-width: 80%;
			}
		}
	}
}
</style>
